module.exports = __webpack_public_path__ + "img/Mstorybg601.2e8adc07.jpg";